import React, { useState } from "react";
import * as Yup from "yup";
import {
  Form as BaseForm,
  TextField,
  SubmitButton,
  CancelPopupButton,
} from "../../../ui/FormElement";
import { useTeamContext } from "../../../contexts/TeamContext";

export default function CreateForm({ closeForm }) {
  let FormSchema = Yup.object().shape({
    title: Yup.string().required("Team name is required"),
  });

  let [loader, setLoader] = useState(false);

  const { dispatch, state, actions } = useTeamContext();

  const [formData, setFormData] = useState({
    title: "",
  });

  const formSendSuccess = () => {
    swal({
      title: "Team Created!",
      text: "",
      html: true,
      type: "success",
      showCancelButton: false,
      confirmButtonText: "Close",
      closeOnConfirm: true,
    });
  };

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(false);
    setLoader(true);

    actions.addTeam(dispatch, state.enterpriseId, values, () => {
      setLoader(false);
      closeForm();
      formSendSuccess();
      actions.loadTeams(state.enterpriseId, dispatch);
    });
  };

  return (
    <BaseForm
      enableReinitialize
      validationSchema={FormSchema}
      initialValues={formData}
      onSubmit={onSubmit}
    >
      <TextField
        name="title"
        label={
          <>
            <span>Team Name</span>
            <abbr title="required">*</abbr>
          </>
        }
      />

      <div className="text-center mt50 mb30">
        <CancelPopupButton
          className="btn btn-primary btn-outline mr5 ml5 width-120"
          title="Cancel"
          onClick={closeForm}
        />
        <SubmitButton
          title={loader ? "Please, wait ..." : "Save"}
          className={`btn width-120 btn-primary submit-button mr5 ml5 ${
            loader ? "not-possible-click" : ""
          }`}
        />
      </div>
    </BaseForm>
  );
}
